import React, { useState } from 'react';
import { Dumbbell } from 'lucide-react';
import { products, Product } from '../data/products';
import { ProductCard } from './ProductCard';
import { ProductModal } from './ProductModal';
interface ProductsSectionProps {
  activeBrand?: string | null;
  onBrandFilter?: (brand: string | null) => void;
}
export function ProductsSection({
  activeBrand = null,
  onBrandFilter
}: ProductsSectionProps) {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const filteredProducts = products.filter(product => {
    if (!activeBrand) return true;
    if (activeBrand === 'Cibeles') return product.id <= 10;
    if (activeBrand === 'Profit') return product.id > 10;
    return true;
  });
  const getSectionTitle = () => {
    if (activeBrand === 'Cibeles') return 'Productos Cibeles';
    if (activeBrand === 'Profit') return 'Productos Profit';
    return 'Nuestros Productos';
  };
  return <section className="bg-dark-900 py-[80px] px-5" id="productos" data-id="element-400">
      <div className="max-w-[1100px] mx-auto" data-id="element-401">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white flex items-center justify-center gap-3 transition-all duration-300" data-id="element-402">
          <Dumbbell className="w-8 h-8 text-alphaGold" data-id="element-403" /> {getSectionTitle()}
        </h2>
        <p className="text-center text-[#aaa] mb-8 text-[1.05rem]" data-id="element-404">
          Hacé click en cualquier producto para ver todos los detalles y hacer
          tu pedido
        </p>

        {/* Brand Tabs */}
        <div className="flex justify-center gap-2 sm:gap-4 mb-12 flex-wrap" data-id="element-405">
          <button onClick={() => onBrandFilter && onBrandFilter(null)} className={`px-6 py-2.5 rounded-full font-bold text-sm sm:text-base uppercase tracking-wider transition-all duration-300 ${!activeBrand ? 'bg-alphaGold text-dark-900 shadow-[0_0_15px_rgba(212,160,23,0.4)]' : 'bg-dark-700 text-[#aaa] hover:bg-dark-600 hover:text-white border border-dark-500'}`} data-id="element-406">
            Todos
          </button>
          <button onClick={() => onBrandFilter && onBrandFilter('Cibeles')} className={`px-6 py-2.5 rounded-full font-bold text-sm sm:text-base uppercase tracking-wider transition-all duration-300 ${activeBrand === 'Cibeles' ? 'bg-alphaGold text-dark-900 shadow-[0_0_15px_rgba(212,160,23,0.4)]' : 'bg-dark-700 text-[#aaa] hover:bg-dark-600 hover:text-white border border-dark-500'}`} data-id="element-407">
            Cibeles
          </button>
          <button onClick={() => onBrandFilter && onBrandFilter('Profit')} className={`px-6 py-2.5 rounded-full font-bold text-sm sm:text-base uppercase tracking-wider transition-all duration-300 ${activeBrand === 'Profit' ? 'bg-alphaGold text-dark-900 shadow-[0_0_15px_rgba(212,160,23,0.4)]' : 'bg-dark-700 text-[#aaa] hover:bg-dark-600 hover:text-white border border-dark-500'}`} data-id="element-408">
            Profit
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[30px]" data-id="element-409">
          {filteredProducts.map(product => <ProductCard key={product.id} product={product} onClick={() => setSelectedProduct(product)} data-id="element-410" />)}
        </div>
      </div>

      <ProductModal product={selectedProduct} onClose={() => setSelectedProduct(null)} data-id="element-411" />
    </section>;
}